/* Défi d’équipe — TC-02 (Bible §52 · v3.2.2 §7).
   The shared goal is the default view. In individual mode the manager sees
   contributions, not a ranking — the ranked view is an explicit toggle, and
   a participant never sees anyone else’s numbers. What is measured is
   invitations offered: never reviews received, never service quality.
   An improbable pattern flags for review; it never accuses.
   v3.3 migration (pack equipe-qr, WF-034): the « Défi collectif » head — eyebrow « Équipe », the one-sentence subtitle,
   « Créer un défi », the scoring line (tests, duplicates, reviews, ratings and follows score nothing — guardrail-aligned)
   and the retired-members line. The challenge data has no empty state (the mock always answers one): none is invented. */
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Card, ErrorState, ListRow, Note } from '@/ui'
import { useChallenge } from './api'
import { Chargement } from './parts'

export default function Defi() {
  const { data, isPending, isError, refetch } = useChallenge()
  const nav = useNavigate()
  const [classe, setClasse] = useState(false)

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger le défi."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const d = data
  const pct = Math.min(100, Math.round((d.achieved / d.goal) * 100))
  const contributions = classe
    ? [...d.contributions].sort((a, b) => b.count - a.count)
    : d.contributions

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 760 }} data-testid="defi-collectif">
      <p className="f-help" style={{ margin: 0 }}><Link to="/equipe">‹ Revenir à l’équipe</Link></p>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 320px', display: 'grid', gap: 2 }}>
          <p className="t-eyebrow" style={{ margin: 0 }}>Équipe</p>
          <h1 className="t-page" style={{ margin: 0 }}>Défi collectif</h1>
          <p className="f-help" style={{ margin: 0 }}>Un objectif commun de participations BMR, sans classement individuel.</p>
        </div>
        <Button variant="primary" size="sm" onClick={() => nav('/equipe/defi/nouveau')}>Créer un défi</Button>
      </div>
      <p className="f-help" style={{ margin: 0 }}>Une participation éligible identifiée = un point. Tests, doublons d’une même visite, avis, notes et abonnements ne rapportent aucun point. Les membres retirés restent présents dans l’attribution passée.</p>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="t-section" style={{ margin: 0, fontSize: 19 }}>Défi d’équipe — {d.name}</h2>
        <span className="f-help" style={{ marginLeft: 'auto' }}>vue responsable · {d.scope}</span>
      </div>

      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
          <b>Objectif d’équipe — {d.name}</b>
          <span><b>{d.achieved}</b> / {d.goal}</span>
        </div>
        <div style={{ height: 8, borderRadius: 5, background: 'var(--bmr-border)', overflow: 'hidden', marginTop: 6 }}>
          <div style={{ height: '100%', width: `${pct}%`, background: 'var(--bmr-action)' }} />
        </div>
        <p className="f-help" style={{ marginTop: 6 }}>Mesure&nbsp;: {d.measure}.</p>
      </Card>

      {d.contributions.length > 0 && (
        <section>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <p className="t-eyebrow" style={{ margin: 0 }}>Contributions (mode optionnel)</p>
            <span className="tabs" style={{ marginLeft: 'auto' }}>
              <button type="button" className={'tab' + (classe ? ' on' : '')}
                onClick={() => setClasse(v => !v)}>vue classée</button>
            </span>
          </div>
          {contributions.map(c => <ListRow key={c.id} title={c.name} meta={c.meta} />)}
        </section>
      )}

      {d.flag && <Note tone="candour">⚠ {d.flag}</Note>}
    </div>
  )
}
